import React from 'react';
import * as FaIcons from 'react-icons/fa'
import * as SiIcons from 'react-icons/si'

export const SidebarData = [
    // {
    //     title: 'Dashboard',
    //     path: '/dashboard',
    //     icon: <FaIcons.FaChartLine />,
    //     class: 'disabled'
    // },
    {
        title: 'Control de Gestión',
        path: '/control-gestion',
        icon: <FaIcons.FaBars />,
        class: ''
    },
    {
        title: 'Planificación',
        path: '/planning',
        icon: <FaIcons.FaMapMarkedAlt />,
        class: ''
    },
    {
        title: 'Primera Milla',
        path: '/first-mile',
        icon: <FaIcons.FaBoxOpen />,
        class: ''
    },
    {
        title: 'Cierre de Conductores',
        path: '/mantenedores',
        icon: <FaIcons.FaBalanceScale />,
        class: ''
    },
    {
        title: 'Gestión Almacen',
        path: '/wms',
        icon: <FaIcons.FaSync />,
        class: 'disabled'
    },
    // {
    //     title: 'Cierre de Conductores',
    //     path: '/cierre',
    //     icon: <FaIcons.FaBalanceScale />,
    //     class: ''
    // },
    {
        title: 'Sorting',
        path: '/sorting',
        icon: <FaIcons.FaClipboardList />,
        class: 'disabled'
    },
    {
        title: 'Última Milla',
        path: '/lastmile',
        icon: <FaIcons.FaPeopleCarry />,
        class: 'disabled'
    },
    {
        title: 'Logística Inversa',
        path: '/reverse-logistic',
        icon: <FaIcons.FaUndoAlt />,
        class: 'disabled'
    },
    {
        title: 'Búsqueda',
        path: '/search',
        icon: <FaIcons.FaSearch />,
        class: 'disabled'
    },
    // {
    //     title: 'Test',
    //     path: '/test',
    //     icon: <SiIcons.SiTestinglibrary />,
    //     class: ''
    // },
    // {
    //     title: 'Test2',
    //     path: '/test2',
    //     icon: <SiIcons.SiTestinglibrary />,
    //     class: ''
    // },

]
